export default {
    bloglist: {
        en: [
            // {
            //     title: 'GBWhatsApp Latest Update News 2026',
            //     poster: require('@/assets/blog.webp'),
            //     desc: 'Stay updated with the latest GBWhatsApp changelog, fixes, and feature improvements.',
            //     name: 'en-blog-update-2026',
            //     url: '/blog/gbwhatsapp-update-2026/',
            //     date: '2026-03-10',
            // },
        ],
    }
}
